export interface BulletItemModel {
  message: string;
  icon: string;
  title?: string;
  tooltip?: boolean;
}
